import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button } from '@iho-design-system/Loader';

const RequestAction = ({ selectedService, sendRequestStatus, toggleTabProps, cancelTicketProps }) => {

    if (selectedService === 'cancel' || selectedService === 'invoice') {
        sendRequestStatus = true;
    } else if ((selectedService === 'cancel' || selectedService === 'invoice') && sendRequestStatus === false) {
        sendRequestStatus = false;
    }

    return (

        <React.Fragment>

            {(selectedService !== '' && selectedService !== 'awaiting' && selectedService !== 'pending') &&
                <Box
                    className={`d-flex`}
                    ms={{
                        gap: 'var(--sizing-xs)'
                    }}>
                    {sendRequestStatus === true &&
                        <Button
                            onClick={() => toggleTabProps(`${selectedService}Finished`)}
                            className={`w-100`}
                            variant='filled'
                            color='primary'>
                            تایید و ارسال
                        </Button>
                    }
                    {sendRequestStatus === false &&
                        <Button
                            className={`w-100 text-dark disabled`}
                            variant='filled'
                            ms={{
                                backgroundColor: 'var(--gray-medium) !important'
                            }}>
                            تایید و ارسال
                        </Button>
                    }
                    <Button
                        onClick={() => toggleTabProps('home')}
                        className={`w-100`}
                        variant='outlined'
                        color='primary'>
                        انصراف
                    </Button>
                </Box>
            }
            {(selectedService === 'awaiting') &&
                <Box
                    className={`d-flex`}
                    ms={{
                        gap: 'var(--sizing-xs)'
                    }}>
                    <Button
                        onClick={cancelTicketProps}
                        className={`w-100`}
                        variant='outlined'
                        color='danger'>
                        حذف درخواست
                    </Button>
                    <Button
                        onClick={() => toggleTabProps('home')}
                        className={`w-100`}
                        variant='outlined'
                        color='primary'>
                        بازگشت به منوی اصلی
                    </Button>
                </Box>
            }
            {selectedService === 'pending' &&
                <Box
                    className={`d-flex`}
                    ms={{
                        gap: 'var(--sizing-xs)'
                    }}>
                    <Button
                        onClick={() => toggleTabProps('home')}
                        className={`w-100`}
                        variant='outlined'
                        color='primary'>
                        بازگشت به منوی اصلی
                    </Button>
                </Box>
            }

        </React.Fragment>

    );

}

export default RequestAction;